import React from 'react';
import './WhyNow.css';

const WhyNow = () => {
  return (
    <section className="why-now-section">
      <div className="why-now-container">
        <div className="questionmark-bg">
          <img src="/images/questionmark.svg" alt="" />
        </div>
        <div className="why-now-intro">
          <div className="why-now-line"></div>
          <span className="why-now-badge">WHY NOW</span>
        </div>
        <p className="why-now-description-header">
          Regulated AI Is No Longer Optional.
        </p>
        <p className="why-now-description-one">
          Global demand is accelerating for explainable, compliant, and production-ready AI;
          especially in healthcare, manufacturing, finance, and government. The next AI category winner
          won’t just build better models. It will turn regulated complexity into a repeatable system.
          <span style={{ position: 'relative', top: '12px' }}>
            <br />
            That’s what Cognitva is building.
          </span>
        </p>
      </div>
    </section>
  );
};

export default WhyNow; 